<template>
    <div>
        <ScrollArrowMenu
                :data="data"
                :open="open"
                :translationType="translationType"
                :bg-color-arrows="bgColorArrows"
                :class="fontWeight"
                :font-weight="fontWeight"
                @menuClicked="menuClicked"
                v-if="!isMobile"
        />
        <SelectBox
                class="darkest-blue"
                :options="data"
                :translationType="translationType"
                @selectChange="selectChange"
                :currentIndex="currentIndex()"
                :is-menu="true"
                v-else
        />
    </div>
</template>

<script>
import SelectBox from "./SelectBox";
import ScrollArrowMenu from './ScrollArrowMenu'
import { mapGetters } from 'vuex'
const _ = require('lodash')
export default {
    name: "ScrollOrSelect",
    components: {
        SelectBox,
        ScrollArrowMenu,
    },
    computed: {
        ...mapGetters({
            isMobile: 'settings/isMobile',
        })
    },
    props:{
        data: Object,
        open: String,
        fontWeight: String,
        translationType: String,
        bgColorArrows: {
            type: String,
            default: 'bg-transparent'
        }
    },
    methods: {
        menuClicked(sport) {
            this.$emit('menuClicked', sport)
        },
        currentIndex(){
            let currentIndex = null
            let firstIndex = null
            _.forEach(this.data, (object, index) => {
                if(firstIndex === null){
                    firstIndex = index
                }
                if(object.name === this.open){
                    currentIndex = index
                }
            })
            currentIndex = currentIndex === null? firstIndex: currentIndex
            return currentIndex
        },
        selectChange(selectedIndex) {
            let objSelected = _.head(_.filter(this.data, (obj, index) => selectedIndex === index))
            this.menuClicked(objSelected.name)
        },
    }
}
</script>

<style scoped>

</style>